import { CollegeAccountsResponse } from "infrastructure/services/types/college.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  hasCardBlack: false,
  idfPerson: "",
  accounts: [],
} as CollegeAccountsResponse;

export const collegeAccountsReducer = createSlice({
  name: "CollegeAccountsReducer",
  initialState,
  reducers: {
    saveCollegeAccounts: (state, action: PayloadAction<CollegeAccountsResponse>) => {
      return action.payload;
    },
    resetCollegeAccounts: () => {
      return initialState;
    },
  },
});

export const { resetCollegeAccounts, saveCollegeAccounts } = collegeAccountsReducer.actions;

export const getCollegeAccounts = (state: RootState) => { return state };

export const getCollegeAccountsNumbers = (state: RootState) => { return state.collegeAccountsReducer.accounts };

export const getCollegeAccountsHasCardBlack = (state: RootState) => { return state.collegeAccountsReducer.hasCardBlack };

export const getCollegeAccountsIdfPerson = (state: RootState) => state.collegeAccountsReducer.idfPerson;

export default collegeAccountsReducer.reducer;
